<!-- navbar-with-sidebar.component.html -->

<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

<!-- Sidebar Overlay -->
<div class="sidebar-overlay" [class.active]="sidebarOpen" (click)="closeSidebar()"></div>

<!-- Sliding Sidebar -->
<div class="sidebar" [class.open]="sidebarOpen">
<div class="sidebar-header">
    <svg xmlns="http://www.w3.org/2000/svg" width="118.267" height="22.088" viewBox="0 0 118.267 22.088">
        <g id="AptaraLogo-REVERSE" transform="translate(283.906 53.022)">
            <g id="Group_88" data-name="Group 88" transform="translate(-283.906 -53.022)">
                <path id="Path_2444" data-name="Path 2444"
                    d="M17.531,22.088,15.3,17.182H5.138L2.9,22.088H0L10.217,0,20.433,22.088Zm-3.338-7.256L10.217,6.124,6.269,14.831Z"
                    fill="#fff" />
                <path id="Path_2445" data-name="Path 2445"
                    d="M121.926,1.812c3.773,0,6.676,2.235,6.676,6.588,0,4.325-2.9,6.56-6.676,6.56h-5.834v8.562h-2.671V1.812Zm-5.863,10.8h5.543A3.956,3.956,0,0,0,125.874,8.4a3.949,3.949,0,0,0-4.267-4.237h-5.543Z"
                    transform="translate(-89.798 -1.435)" fill="#fff" />
                <path id="Path_2446" data-name="Path 2446"
                    d="M204.42,4.162V23.521h-2.67V4.162h-8.069V1.811h18.808V4.162Z"
                    transform="translate(-153.34 -1.434)" fill="#fff" />
                <path id="Path_2447" data-name="Path 2447"
                    d="M392.211,14.814h-5.66v8.707h-2.67V1.811h8.388c3.744,0,6.676,2.177,6.676,6.5,0,3.193-1.6,5.224-3.976,6.066l5.108,9.143h-2.989Zm-.261-2.351a3.925,3.925,0,0,0,4.267-4.15,3.925,3.925,0,0,0-4.267-4.151h-5.427v8.3Z"
                    transform="translate(-303.924 -1.434)" fill="#fff" />
                <path id="Path_2448" data-name="Path 2448"
                    d="M487.242,22.088l-2.235-4.905H474.848l-2.235,4.905h-2.9L479.928,0l10.217,22.088ZM483.9,14.831l-3.976-8.708-3.947,8.708Z"
                    transform="translate(-371.877)" fill="#fff" />
                <path id="Path_2449" data-name="Path 2449"
                    d="M280.552,6.124,287.9,22.088h2.871L280.552,0,270.335,22.088h2.871Z"
                    transform="translate(-214.029 0)" fill="#fff" />
                <path id="Path_2450" data-name="Path 2450"
                    d="M17.531,22.088,15.3,17.182H5.138L2.9,22.088H0L10.217,0,20.433,22.088Zm-3.338-7.256L10.217,6.124,6.269,14.831Z"
                    fill="#fff" />
                <path id="Path_2451" data-name="Path 2451"
                    d="M121.926,1.812c3.773,0,6.676,2.235,6.676,6.588,0,4.325-2.9,6.56-6.676,6.56h-5.834v8.562h-2.671V1.812Zm-5.863,10.8h5.543A3.956,3.956,0,0,0,125.874,8.4a3.949,3.949,0,0,0-4.267-4.237h-5.543Z"
                    transform="translate(-89.798 -1.435)" fill="#fff" />
                <path id="Path_2452" data-name="Path 2452"
                    d="M204.42,4.162V23.521h-2.67V4.162h-8.069V1.811h18.808V4.162Z"
                    transform="translate(-153.34 -1.434)" fill="#fff" />
                <path id="Path_2453" data-name="Path 2453"
                    d="M392.211,14.814h-5.66v8.707h-2.67V1.811h8.388c3.744,0,6.676,2.177,6.676,6.5,0,3.193-1.6,5.224-3.976,6.066l5.108,9.143h-2.989Zm-.261-2.351a3.925,3.925,0,0,0,4.267-4.15,3.925,3.925,0,0,0-4.267-4.151h-5.427v8.3Z"
                    transform="translate(-303.924 -1.434)" fill="#fff" />
                <path id="Path_2454" data-name="Path 2454"
                    d="M487.242,22.088l-2.235-4.905H474.848l-2.235,4.905h-2.9L479.928,0l10.217,22.088ZM483.9,14.831l-3.976-8.708-3.947,8.708Z"
                    transform="translate(-371.877)" fill="#fff" />
                <path id="Path_2455" data-name="Path 2455"
                    d="M280.552,6.124,287.9,22.088h2.871L280.552,0,270.335,22.088h2.871Z"
                    transform="translate(-214.029 0)" fill="#fff" />
            </g>
        </g>
    </svg>
    <button class="sidebar-close" (click)="closeSidebar()" aria-label="Close menu">
        <i class="pi pi-times"></i>
    </button>
</div>

  <nav class="sidebar-nav">
    <p class="sidebar-section-label">Navigation</p>

    <a class="sidebar-link" routerLink="/getDeleteTimesheet" (click)="closeSidebar()">
      <i class="pi pi-trash"></i>
      <span>Delete Timesheets</span>
    </a>

    <a class="sidebar-link" routerLink="/query-builder" (click)="closeSidebar()">
      <i class="pi pi-database"></i>
      <span>Query Builder</span>
    </a>

  </nav>

  <!-- <div class="sidebar-footer">
    <span>Celoxis Timesheet Portal</span>
    <span class="sidebar-version">v1.0</span>
  </div> -->
</div>

<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-light" style="background-color: #0057B8;">
  <div class="container-fluid">

    <!-- Hamburger toggle -->
    <button class="sidebar-toggle"  *ngIf="isValidUserForSidebar" (click)="toggleSidebar()" aria-label="Open menu">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <a class="navbar-brand" routerLink="/timesheet">
      <svg xmlns="http://www.w3.org/2000/svg" width="118.267" height="22.088" viewBox="0 0 118.267 22.088">
        <g id="AptaraLogo-REVERSE" transform="translate(283.906 53.022)">
          <g id="Group_88" data-name="Group 88" transform="translate(-283.906 -53.022)">
            <path id="Path_2444" d="M17.531,22.088,15.3,17.182H5.138L2.9,22.088H0L10.217,0,20.433,22.088Zm-3.338-7.256L10.217,6.124,6.269,14.831Z" fill="#fff"/>
            <path id="Path_2445" d="M121.926,1.812c3.773,0,6.676,2.235,6.676,6.588,0,4.325-2.9,6.56-6.676,6.56h-5.834v8.562h-2.671V1.812Zm-5.863,10.8h5.543A3.956,3.956,0,0,0,125.874,8.4a3.949,3.949,0,0,0-4.267-4.237h-5.543Z" transform="translate(-89.798 -1.435)" fill="#fff"/>
            <path id="Path_2446" d="M204.42,4.162V23.521h-2.67V4.162h-8.069V1.811h18.808V4.162Z" transform="translate(-153.34 -1.434)" fill="#fff"/>
            <path id="Path_2447" d="M392.211,14.814h-5.66v8.707h-2.67V1.811h8.388c3.744,0,6.676,2.177,6.676,6.5,0,3.193-1.6,5.224-3.976,6.066l5.108,9.143h-2.989Zm-.261-2.351a3.925,3.925,0,0,0,4.267-4.15,3.925,3.925,0,0,0-4.267-4.151h-5.427v8.3Z" transform="translate(-303.924 -1.434)" fill="#fff"/>
            <path id="Path_2448" d="M487.242,22.088l-2.235-4.905H474.848l-2.235,4.905h-2.9L479.928,0l10.217,22.088ZM483.9,14.831l-3.976-8.708-3.947,8.708Z" transform="translate(-371.877)" fill="#fff"/>
            <path id="Path_2449" d="M280.552,6.124,287.9,22.088h2.871L280.552,0,270.335,22.088h2.871Z" transform="translate(-214.029 0)" fill="#fff"/>
            <path id="Path_2450" d="M17.531,22.088,15.3,17.182H5.138L2.9,22.088H0L10.217,0,20.433,22.088Zm-3.338-7.256L10.217,6.124,6.269,14.831Z" fill="#fff"/>
            <path id="Path_2451" d="M121.926,1.812c3.773,0,6.676,2.235,6.676,6.588,0,4.325-2.9,6.56-6.676,6.56h-5.834v8.562h-2.671V1.812Zm-5.863,10.8h5.543A3.956,3.956,0,0,0,125.874,8.4a3.949,3.949,0,0,0-4.267-4.237h-5.543Z" transform="translate(-89.798 -1.435)" fill="#fff"/>
            <path id="Path_2452" d="M204.42,4.162V23.521h-2.67V4.162h-8.069V1.811h18.808V4.162Z" transform="translate(-153.34 -1.434)" fill="#fff"/>
            <path id="Path_2453" d="M392.211,14.814h-5.66v8.707h-2.67V1.811h8.388c3.744,0,6.676,2.177,6.676,6.5,0,3.193-1.6,5.224-3.976,6.066l5.108,9.143h-2.989Zm-.261-2.351a3.925,3.925,0,0,0,4.267-4.15,3.925,3.925,0,0,0-4.267-4.151h-5.427v8.3Z" transform="translate(-303.924 -1.434)" fill="#fff"/>
            <path id="Path_2454" d="M487.242,22.088l-2.235-4.905H474.848l-2.235,4.905h-2.9L479.928,0l10.217,22.088ZM483.9,14.831l-3.976-8.708-3.947,8.708Z" transform="translate(-371.877)" fill="#fff"/>
            <path id="Path_2455" d="M280.552,6.124,287.9,22.088h2.871L280.552,0,270.335,22.088h2.871Z" transform="translate(-214.029 0)" fill="#fff"/>
          </g>
        </g>
      </svg>
    </a>

    <div class="celoxis-portal">
      <p>Celoxis Timesheet Portal</p>
    </div>

    <div class="navbar-collapse justify-content-end" id="navbarScroll">
      <ul class="navbar-nav">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarScrollingDropdown"
             role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span *ngIf="FirstName" class="user-name">
              <strong>{{ LoggedUserName }} {{ SirName }}</strong>
            </span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarScrollingDropdown">
            <li><a class="dropdown-item" type="submit" routerLink="/login"
                   (click)="clearLocalStorage()">Logout</a></li>
          </ul>
        </li>
      </ul>
    </div>

  </div>
</nav>